import React, { useState } from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { Beleidsplan } from "../components/beleidsplan"
import { Project } from "../components/project"
import * as styles from "../components/tabs.module.css"

const Tab = props => {
  return (
    <button className={props.status ? styles.tabButtonAan : styles.tabButtonUit} onClick={props.func}>
      {props.children}
      <hr className={props.status ? styles.hrStyleAan : styles.hrStyleUit} />
    </button>
  )
}

const ProjectTabs = () => {
  const [tab1, setTab1] = useState(true)
  const [tab2, setTab2] = useState(false)

  const HandleClick = tabNr => {
    if (tabNr === "tab1") {
      setTab1(true)
      setTab2(false)
    }

    if (tabNr === "tab2") {
      setTab1(false)
      setTab2(true)
    }
  }

  return (
    <Layout>
      <Seo title="Project" />
      <div className={styles.tab}>
        <Tab status={tab1} func={() => HandleClick("tab1")}>
          <big>Beleidsplan 2023-2025</big>
        </Tab>
        <Tab status={tab2} func={() => HandleClick("tab2")}>
          <big>Algemeen</big>
        </Tab>
      </div>

      <div id="tab1" className={tab1 ? styles.tabContentAan : styles.tabContentUit}>
        <Beleidsplan />
      </div>

      <div id="tab2" className={tab2 ? styles.tabContentAan : styles.tabContentUit}>
        <Project />
      </div>
    </Layout>
  )
}
export default ProjectTabs
